
import { Button, Col, Form, Input, notification, Row, Select } from "antd"
import { useParams } from "react-router-dom";
import { addTagApi } from "../../../../../../config/Api";
import { API_ERR_MESSAGE } from "../../../../../../config/constant";


export const AddTags = (props) => {
    const [form] = Form.useForm();
    const { Option } = Select;
    const { id } = useParams()


    const onFinish = (values) => {
        // const date = moment(new Date()).format('DD-MMMM-YYYY');
        const data = {
            "tag": values.Tag,
            "note": values.note,
            "patient_id": id,
        }

        addTagApi(data)
            .then((res) => {
                if (res.status == 200) {
                    notification.success({
                        message: "Tag added successfully",
                    });
                    form.resetFields()
                    props.getListOfTags()
                    props.setIsModalVisible(false)
                    props?.setTagData(!props?.tagData)
                }
            })
            .catch((err) => {
                notification.error({
                    message: API_ERR_MESSAGE,
                });
            });
        // console.log(values);
    };

    const resetData = () => {
        form.resetFields()
    };
    return (
        <Form
            name="addTag"
            className="addTag"
            form={form}
            onFinish={onFinish}
        >
            <div className="logoSection">
                <h4 className="mb-0">Add Tags</h4>
            </div>
            <Row gutter={[16, { xs: 8, sm: 16, md: 24, lg: 8 }]} className="mt-3">
                <Col xs={24} md={24} xl={11} xxl={24}>
                    <label className="form-input-label">
                        Tag
                        <span className="asterik"> *</span>
                    </label>
                    <Form.Item
                        name="Tag"
                        rules={[
                            {
                                required: true,
                                message: "Please Select Tag!",
                            },
                        ]}
                        initialValue=""
                    >
                        <Select
                            className="mt-2"
                        // value={regType}
                        // onChange={(e) => setRegType(e)}
                        >
                            <Option value="" disabled hidden>
                                Select Tag
                            </Option>
                            <Option value="Complaining">Complaining</Option>
                            <Option value="Happy">Happy</Option>
                            <Option value="International">International</Option>
                            <Option value="VIP">VIP</Option>
                            <Option value="Break">Break</Option>
                            <Option value="RNR">RNR</Option>
                            <Option value="Stuck Weight">Stuck Weight</Option>
                        </Select>
                    </Form.Item>
                </Col>
                <Col xs={24} md={24} xl={11} xxl={24}>
                    <label className="form-input-label">
                        Note
                        <span className="asterik"> *</span>
                    </label>
                    <Form.Item
                        name="note"
                        rules={[
                            {
                                required: true,
                                message: "Please Enter Note!",
                            },
                        ]}
                    >
                        <Input.TextArea
                            placeholder="Write your Note"
                            showCount
                            maxLength={254}
                            className="mt-2"

                        />
                    </Form.Item>
                </Col>
                <Col span={24} className="text-center">
                    <Button htmlType="submit" className="submit-button b-0 rounded">
                        SAVE
                    </Button>
                    <Button onClick={() => resetData()} className="reset-button ms-4 b-0 rounded">
                        RESET
                    </Button>
                </Col>
            </Row>
        </Form>

    )
}